import React from 'react';
import { useTranslation } from 'react-i18next';
import { Typography, Button, Link } from '@mui/material';
import workersImg from 'src/img/workers.svg';
import basicLogoImg from 'src/img/basic-logo.svg';
import useStyles from './styles';
export default function MobilePage() {
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement("div", {
    className: classes.mobilePage
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.mobileContent
  }, /*#__PURE__*/React.createElement("img", {
    alt: "basic logo",
    src: basicLogoImg,
    height: "23",
    width: "138"
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.xsSection
  }, /*#__PURE__*/React.createElement("img", {
    alt: "workers image",
    src: workersImg,
    height: "159",
    width: "199"
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.lgSection
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h2"
  }, t('mobile.mobile_header'))), /*#__PURE__*/React.createElement("div", {
    className: classes.xsSection
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body3",
    component: "p"
  }, t('mobile.mobile_text'))), /*#__PURE__*/React.createElement("div", {
    className: classes.xlSection
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    size: "small",
    target: "_blank",
    component: Link,
    href: "https://comesave.livable.com/meetings/livable/livable-pro-onboarding",
    'custom-attribute': '29-mobile-page'
  }, t('mobile.interested')))));
}